export const PLATFORM_TYPE = [
  {
    title: 'pc',
    val: 'pc',
  },
  {
    title: 'app',
    val: 'app',
  },
  {
    title: 'm',
    val: 'm',
  },
  {
    title: 'wq',
    val: 'wq',
  },
  {
    title: '未知',
    val: '未知',
  },
];
export const REALTIME_TYPE = [
  {
    title: '实时',
    val: true,
  },
  {
    title: '离线',
    val: false,
  },
];

export const PLATFORM_TYPE_MAP = {};

export const REALTIME_TYPE_MAP = {};

function transformArr2Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.val] = item.title;
  });
}
transformArr2Map(PLATFORM_TYPE, PLATFORM_TYPE_MAP);
transformArr2Map(REALTIME_TYPE, REALTIME_TYPE_MAP);
